import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from './actionHelpers';

export const NEWS_ARTICLES_LIST = 'NEWS_ARTICLES_LIST';
export const NEWS_ARTICLES_GET = 'NEWS_ARTICLES_GET';

export const fetchNewsArticles = () => {
    return {
        [RSAA]: {
            types: createRsaaTypes(NEWS_ARTICLES_LIST),
            endpoint: '/api/newsArticles',
            headers: createHeaders(false),
            method: 'GET'
        }
    };
};

export const fetchNewsArticle = newsArticleId => {
    return {
        [RSAA]: {
            types: createRsaaTypes(NEWS_ARTICLES_GET),
            endpoint: `/api/newsArticles/${newsArticleId}`,
            headers: createHeaders(false),
            method: 'GET'
        }
    };
};
